<template>
  <div class="user-status" v-if="show">
    <div class="status-msg pending" v-if="tip_status === 0">
      <i class="icon-y-Pending status-icon"></i>
      <div class="msg">
        <p class="tit">Your account is under review!</p>
        <p class="content">Please make sure your contact information is accurate, or you can <a @click="contact">Contact AM</a></p>
        <p class="note">(Please notice that, you can't get the offers,unless your account is active.)</p>
      </div>
      <i class="icon-y-wrong wrong-icon" @click="close"></i>
    </div>

    <div class="status-msg rejected" v-if="tip_status === 3">
      <i class="icon-y-approved status-icon"></i>
      <div class="msg">
        <p class="tit">Your account is not approved!</p>
        <p class="content">the reasons could be: (1) your traffic is not matching our offers; (2) your contact infomation is invalid.</p>
        <p class="content">if you have any questions please <a @click="contact">Contact AM</a></p>
      </div>
      <i class="icon-y-wrong wrong-icon" @click="close"></i>
    </div>

    <div class="status-msg blocked" v-if="tip_status === 2">

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tip_status: this.status,
      show: true,
    }
  },
  watch: {
    status(newValue) {
      this.tip_status = this.status
    },
  },
  props: {
    status: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    close(){
      this.show = false
    },
    contact(){
      document.getElementById('ticketBtn').click()
    },
  },
}
</script>

<style lang="scss">
.user-status{
  .status-msg{
    box-sizing: border-box;
    padding: 16px 21px;
    margin-top: -34px;
    border-radius: 0px 0px 4px 4px;
    display: flex;
    position: relative;
    .status-icon{
      font-size: 46px;
      margin-right: 16px;
    }
    .msg{
      .tit{
        color: #3F4042;
        font-weight: 600;
        line-height: 24px;
      }
      .content{
        color: #3F4042;
        font-size: 14px;
        line-height: 22px;
      }
      .note{
        color: #76787D;
        font-size: 14px;
        line-height: 22px;
      }
      a{
        padding: 0;
      }
    }
    .wrong-icon{
      color: #9B9EA3;
      font-size: 24px;
      position: absolute;
      top: 12px;
      right: 16px;
      border-radius: 50%;
      &:hover{
        cursor: pointer;
        background: #D1D3D8;
      }
    }
  }
  .pending{
    background: rgba(0, 128, 204, 0.1);
    .status-icon{
      color: #0080CC;
    }
  }
  .rejected{
    background: rgba(243, 60, 152, 0.1);
    .status-icon{
      color: #F33C98;
    }
  }
}
</style>
